<template>
  <div class="about">
    
    <div>
      <router-link to="/"><img src="logo2.png" style="vertical-align:middle;"/></router-link>
      <input class="v-autocomplete-input" ref="sb" @keyup="search" type="search" :value="q">
      <input type="checkbox" id="chk" v-model="showChart"/><label for="chk">차트 렌더링</label>
      <!-- <span style="margin-left:20px;">AP : </span> <span style="weight:bold;">{{ap}}</span> -->
    </div>

    <div>
      <div class="result-wrapper">
        <template v-if="resultSet.length > 0">
          <ul class="result-ul">
            <result-card v-for="item in resultSet" :showChart="showChart" :key="item.vid" :vid="item.vid" :matched="item.matched" />
          </ul>
        </template>
        <template v-else>
          검색결과가 없습니다.
        </template>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import ResultCard from "../components/ResultCard.vue"

export default {

  components: { ResultCard },

  data: () => ({
    ap: 0.0,
    q: window.query || "",
    resultSet: [],
    showChart: false,
    mapSet: {
      "감자" : [419690936, 420168205, 420687628, 421138171, 421557329, 423327915, 424253297, 424671179, 425531832, 425954236, 426391802, 426877410, 427773872, 428213117],
      "루밍" : [413283283, 414286782, 414735658, 415199513, 417023096, 417953096, 418367904, 419695578, 420191778, 421605756, 423335517, 427362987, 429105285],
      "ymq" : [412334252, 412813845, 413216289, 413769881, 414283899, 414729387, 415186037, 415635098, 416084907, 416536326, 417020527, 417812461, 419675555, 419691836, 420154200, 420710538, 421136484, 421555888, 422064227, 422430696, 422851689, 423315844, 423339871, 423800976, 423808029, 424256402, 425647508, 425649019, 426402533, 426896731],
      "새봄추" : [427826743, 428215290, 428256596, 428717372, 429162716, 429648476, 429832536, 430163070, 430668360],
      "차보해" : [428601939, 429051750, 429564491, 430018502, 430145082, 430503965, 430597051, 430991928, 431440690],
      "김진효" : [413283283, 414286782, 414735658, 415199513, 417023096, 417953096, 418367904, 419695578, 420191778, 421605756, 423335517, 427362987, 429105285],
      "이희주" : [412334252, 412813845, 413216289, 413769881, 414283899, 414729387, 415186037, 415635098, 416084907, 416536326, 417020527, 417812461, 419675555, 419691836, 420154200, 420710538, 421136484, 421555888, 422064227, 422430696, 422851689, 423315844, 423339871, 423800976, 423808029, 424256402, 425647508, 425649019, 426402533, 426896731],
      "김성태" : [419690936, 420168205, 420687628, 421138171, 421557329, 423327915, 424253297, 424671179, 425531832, 425954236, 426391802, 426877410, 427773872, 428213117],
      "이상혁" : [398393566, 400494624, 400994662, 413295661, 413372601, 413706876, 413797549, 413874301, 414199949, 414288493, 414368793, 414658885, 414737896, 414826678],
      "윤현우" : [412831781, 414318985, 414755911, 415216287, 415659459, 416122018, 417950645, 418328160, 418833683, 418846216, 419279730, 420713079, 421164760, 421176947, 421581973, 421612824, 422013458, 422448229, 422891086, 423870678, 424278838, 425140461, 425543965, 425563604, 426806355, 426946373, 426954803, 426959199, 426962340, 426966293, 426969524],
      "조현수" : [424993287, 425425439, 427256306, 428102891, 428542276, 429448814, 430440334, 430909303],
      "은돌이" : [427826743, 428215290, 428256596, 428717372, 429162716, 429648476, 429832536, 430163070, 430668360],
      "첵스" : [419690936, 420168205, 420687628, 421138171, 421557329, 423327915, 424253297, 424671179, 425531832, 425954236, 426391802, 426877410, 427773872, 428213117],
      "오즈" : [419690936, 420168205, 420687628, 421138171, 421557329, 423327915, 424253297, 424671179, 425531832, 425954236, 426391802, 426877410, 427773872, 428213117],
      "스웩이" : [413283283, 414286782, 414735658, 415199513, 417023096, 417953096, 418367904, 419695578, 420191778, 421605756, 423335517, 427362987, 429105285],
      "페이커 사일러스 5인궁" : [426391802, 426377000],
      "lck 결승" : [410315530],
      "msi 결승" : [426877410, 426869245],
      "페이커 눈물" : [410315530],
      "페이커 라이즈 2대1" : [410315530],
      "샌프란시스코 쇼크 우승" : [424066354],
      "누누 챌린저 과외" : [431440690],
      "페이커 솔랭" : [398393566, 400494624, 400994662, 413295661, 413372601, 413706876, 413797549, 413874301, 414199949, 414288493, 414368793, 414658885, 414737896, 414826678],
      "2633" : [419690936, 420168205, 420687628, 421138171, 421557329, 423327915, 424253297, 424671179, 425531832, 425954236, 426391802, 426877410, 427773872, 428213117, 413283283, 414286782, 414735658, 415199513, 417023096, 417953096, 418367904, 419695578, 420191778, 421605756, 423335517, 427362987, 429105285, 412334252, 412813845, 413216289, 413769881, 414283899, 414729387, 415186037, 415635098, 416084907, 416536326, 417020527, 417812461, 419675555, 419691836, 420154200, 420710538, 421136484, 421555888, 422064227, 422430696, 422851689, 423315844, 423339871, 423800976, 423808029, 424256402, 425647508, 425649019, 426402533, 426896731],
      "lck 준결승 코르키 죽음의 무도" : [407457306],
      "lck 쇼메이커" : [405423139, 436555262],
      "소드 바이퍼 타잔 쵸비 리헨즈" : [410315530, 403960817],
      "페이커 마타 테디 클리드 칸" : [426377076, 424670121, 424250883, 423792187, 423292744, 422860096, 410315530, 407457306],
      "넨넨 위도우메이커" : [425409699],
      "몰왕 초시계 평타" : [436555262]
    }
  }),

  beforeMount() {
    this.do()
  },

  methods: {

    do(){
      const that = this
      this.fetchFromElastic(this.q).then(res => {
        const resultSet = res.data
                            .aggregations['group_by_vid']
                            .buckets.map(
                              b => ({vid: b.key, score: b['score_sum']['value']})
                            )
        debugger;
        this.resultSet = resultSet.sort((a,b)=> b.score - a.score)
      }).then(()=>{
        debugger;
        const mapObj = {}
        const answerArr = this.mapSet[this.q.trim()]
        const myResultArr = this.resultSet
        let matchCount = 0;

        /*
오전 3:37 14 이희상 일단
오전 3:37 14 이희상 검색에
오전 3:37 14 이희상 연관 영상 몇개인지 보고
오전 3:37 14 이희상 정답셋 갯수보다 작으면
오전 3:38 14 이희상 검색결과중 연관된거/10
오전 3:38 14 이희상 정답셋 갯수랑 같으면
오전 3:38 14 이희상 정답셋수/마지막 정답셋 까지 검색결과 수
오전 3:38 14 이희상 요렇게 해야됨

        */

        this.ap = 0

        for(let i=1; i<=myResultArr.length; i++){
          if( answerArr.indexOf(myResultArr[i-1]['vid']) > -1 ){
            mapObj[myResultArr[i-1]['vid']] = myResultArr[i-1]['vid']
            matchCount++
          }
        }

        if( matchCount === answerArr.length ){ 
          this.ap = Object.values(mapObj).reduce((a, b) => a + b, 0) / ((Object.values(mapObj).length) || 1)
        } else if ( matchCount < answerArr.length ){
          this.ap = matchCount / 10
        }

        this.resultSet = this.resultSet.map(obj => ({ ...obj, matched: !!mapObj[obj.vid] }))
      });
    },

    map(query){

    },

    search(e){
      if(e.keyCode === 13){
        const el = this.$refs.sb
        this.q = window.query = el.value
        this.do()
      }
    },

    fetchFromElastic(txt) {
      return axios.post(
        "https://api.snhyun.me:8881/twitch1/_search",
        {
          query: {
            match: {
              content: `${txt}`
            }
          },
          aggs: {
            group_by_vid: {
              terms: {
                field: "vid"
              },
              aggs: {
                score_sum: {
                  avg: {
                    script: "_score"
                  }
                }
              }
            }
          }
        },
        { headers: { "Content-Type": "application/json" } }
      );
    }
  }
};
</script>

<style lang="css">
.v-autocomplete-input {
  margin: 10px;
  border: 4px solid #6441a4;
  width: 400px;
  height: 45px;
  outline: 0;
  background-color: transparent;
  color: #6441a4;
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
}

.result-ul {
  margin: 0;
  padding: 0;
}

.result-wrapper {
  padding: 20px;
  margin-bottom: 40px;
}
</style>